import styled from '@emotion/styled'
import { css } from '@emotion/core'
import Button from 'portal-modules/common/components/Button'
import { LedgerTable } from 'portal-modules/ledger/components'
import { Form } from '@entrata/portals-common/lib/components/forms'
import { RoundedCheckBox } from 'portal-modules/common/components/checkbox'

export const StyledH2 = styled('h2')`
  color: ${({ theme }) => theme.text.dark};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 16px;
  margin: 40px 0 16px;

  @media screen and (min-width: 768px) and (max-width: 1023px) {
    font-size: 18px;
    font-weight: 600;
  }

  &:not(:first-child) {
    margin-top: 32px;

    @media screen and (min-width: 1024px) {
      margin-top: 48px;
    }
  }
`

export const StyledWrapperSection = styled('section')`
  font-size: 13px;

  &:not(:last-child) {
    margin-bottom: 32px;
  }

  @media screen and (min-width: 768px) {
    font-size: 16px;
  }
`

export const StyledUL = styled('ul')`
  list-style-type: none;
  padding: 0;
`

export const StyledSpan = styled('span')`
  color: ${({ theme }) => theme.text.light};
  display: block;
  font-size: 13px;
  font-style: italic;
`

export const StyledH5 = styled('h5')`
  font-size: inherit;
  margin: 32px 0 8px;

  &:first-child {
    margin-top: 24px;
  }
`

export const flexSpaceStyles = css`
  display: flex;
  justify-content: space-between;
`

export const StyledLI = styled('li')`
  ${flexSpaceStyles};

  &.total {
    margin-top: 8px;
    font-weight: bold;
  }
`

export const StyledDetailsSection = styled('section')`
  align-items: center;
  font-size: 16px;
  font-weight: bold;

  @media screen and (min-width: 768px) {
    float: left;
    font-size: 14px;
    font-weight: normal;
    padding-right: 40px;
    width: 50%;
  }
`

export const StyledH4 = styled('h4')`
  margin: 0;

  @media screen and (min-width: 768px) {
    font-size: 18px;
    font-weight: 500;
  }
`

export const StyledCurrencySpan = styled('span')`
  @media screen and (min-width: 768px) {
    color: ${({ theme }) => theme.gray.base};
    font-style: italic;
  }
`

export const StyledRenewalH4 = styled('h4')`
  font-size: 18px;
  font-weight: normal;
  margin: 0;
`

export const StyledEm = styled('em')`
  color: ${({ theme }) => theme.text.light};
  font-size: 14px;
`

export const StyledLedgerTable = styled(LedgerTable)`
  width: 100%;
  margin: 32px 0;
  font-size: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.gray.light};

  & th {
    font-weight: normal;
    font-style: italic;
    text-align: left;
  }

  tbody {
    tr {
      border-bottom: none;
    }

    th {
      background: none;
      padding-left: 16px;
    }
  }

  & thead {
    padding-bottom: 16px @media (max-width: 768px) {
      & tr:first-child {
        border-bottom: none;
      }

      & th {
        padding-top: 24px;
      }
    }

    @media (max-width: 960px) {
      & th {
        &:first-child {
          padding-left: 16px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    border-top: 2px solid ${({ theme }) => theme.gray.light};
    padding-top: 24px;
  }
`

export const StyledTr = styled(LedgerTable.Row)`
  font-size: 16px;

  & td:first-child {
    padding-left: 16px;
  }
`

export const StyledTd = styled(LedgerTable.Col)`
  font-size: 16px;
  &:first-child {
    word-break: break-all;
    padding-right: 16px
    width: 25%;
  }
  &:last-child {
    padding-right: 16px
  }

  @media only screen and (min-width: 768px) {
    padding: 16px 0;
  }
`

export const StyledTdVerticallyTop = styled(LedgerTable.Col)`
  vertical-align: top;
  font-size: 16px;
  &:first-of-type {
    word-break: break-all;
    padding-right: 16px
    width: 25%;
  }
  &:last-of-type {
    padding-right: 16px
  }

  @media only screen and (min-width: 768px) {
    padding: 16px 0;
  }
`

export const StyledCardLI = styled('li')`
  background-color: white;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.gray.light};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  color: ${({ theme }) => theme.text.dark};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 13px;
  padding: 16px;
  width: 100%;
`
export const StyledTitleH4 = styled('h4')`
  margin: 32px 0 8px;

  &:first-child {
    margin-top: 24px;
  }

  @media screen and (min-width: 768px) {
    font-size: 15.5px;
  }
`
export const StyledDiv = styled('div')`
  border-bottom: 2px solid ${({ theme }) => theme.gray.light};
  font-size: 13px;
  margin: 0 -32px 24px;
  padding: 0 32px 16px;

  @media screen and (min-width: 768px) {
    border-bottom: none;
    margin-bottom: 0;
  }
`

export const StyledCardAmount = styled('span')`
  font-size: 14px;
  font-weight: 550;
  display: flex;
  color: ${({ theme }) => theme.text.dark};
`
export const StyledTaxLabelContent = styled('div')`
  font-style: italic;
  font-size: 11px;
  margin-top: 8px;
`

export const StyledAlertDiv = styled('div')`
  color: ${({ theme }) => theme.info.base};
  display: flex;
  margin-top: 10px;
`

export const StyledAlertSpan = styled('span')`
  font-size: 13px;
  font-style: italic;
  margin-left: 8px;
  vertical-align: top;
`

export const StyledArrow = css`
  pointer-events: all !important;
  cursor: pointer;
  width: 18px;
  float: right;
  margin-top: -36px;
  height: 18px;
`
export const StyledArrowNew = css`
  ${StyledArrow};
  margin-top: -18px;
`

export const StyledButton = styled(Button)`
  font-size: 16px;
  line-height: 1.5;
  margin: 0 4px 16px;
`
export const StyledButtonDiv = styled('div')`
  display: flex;
  justify-content: center;
`

// Personal Info form Page

export const StyledH4PI = styled('h4')`
  font-size: 18px;
  margin: 0 0 16px;
`

export const StyledFormPI = styled(Form)`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
`

export const StyledFormContentPI = styled('div')`
  background-color: 'transparent';
  flex-grow: 1;
  overflow: auto;
  padding: 16px 40px;
`

export const StyledAlertDivPI = styled('div')`
  padding: 24px 40px;
  text-align: left;
`
export const StyledAlertEmPI = styled('em')`
  font-size: 13px;
  margin-left: 8px;
  vertical-align: top;
`

export const StyledCheckboxFieldPI = styled(RoundedCheckBox)`
  padding-top: 25px;
  label {
    pointer-events: none;
  }
  @media only screen and (max-width: 767px) {
    padding: 0;
  }
`

export const StyledPetCardTooltipContainer = styled('div')`
  display: flex;
  margin-bottom: 8px;
`

export const StyledPetCardDiv = styled('div')`
  padding: 8px;
`

export const StyledPetCardIcon = styled('span')`
  color: ${({ theme }) => theme.blue.system_blue};
  cursor: pointer;
  margin-left: 8px;
  position: relative;
`
export const StyledWrapperUL = styled('ul')`
  color: ${({ theme }) => theme.text.dark};
  list-style-type: none;
  margin: 0;
  padding: 0;
`
export const StyledWrapperMarginDiv = styled('div')`
  color: ${({ theme }) => theme.text.dark};
  padding: 0;
  margin: 0;
`
export const StyledTextP = styled('p')`
  color: ${({ theme }) => theme.text.dark};
  font-style: normal;
  padding: 0;
  margin: 0;
`
export const StyledListItem = styled('div')`
  padding-bottom: 8px;
`
export const StyledSpiltSpan = styled('span')`
  font-size: 10px;
  color: ${({ theme }) => theme.text.light};
`
export const StyledTermsButton = styled('button')`
  background: none;
  border: none;
  color: ${({ theme }) => theme.blue.system_blue};
  font-size: 8px;
  padding: 0;
  text-align: left;
`
export const StyledWrapperMarginUL = styled('ul')`
  color: ${({ theme }) => theme.text.dark};
  list-style-type: none;
  padding: 0;
  margin-left: 20px;
`
export const StyledListItemText = styled('li')`
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;

  :last-child {
    padding-bottom: 0;
  }
`
export const StyledSpiltSpanText = styled('span')`
  font-size: 12px;
  color: ${({ theme }) => theme.text.light};
  font-style: italic;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`
export const StyledCloseButton = styled(Button)`
  min-width: 100%;
`
export const StyledName = styled('span')`
  color: ${({ theme }) => theme.text.dark};
  font-style: normal;
  font-size: 14px;
`
export const StyledAmountSpan = styled('span')`
  color: ${({ theme }) => theme.text.dark};
  font-weight: bold;
  font-style: normal;
`
export const StyledConditionButton = styled('button')`
  background: none;
  border: none;
  color: ${({ theme }) => theme.blue.system_blue};
  font-size: 8px;
  padding: 5px 0;
  text-align: left;
`
